import { useContext } from "react";
import { LoggerContext } from "../state/logger";

export function useLogger() {
  return useContext(LoggerContext)
}
